import { queryOptions } from '@tanstack/react-query';

import { ListViewDTO } from '@invenco/accounts-interface';

import { TABLE_IDS } from '@/constants';
import { AccountsGateway } from '@/gateways/impl/AccountsGateway';
import { fetchAllPages } from '@/shared/helpers';

export const listViewsQueryOptions = (accountsGateway: AccountsGateway, listId?: string) =>
  queryOptions({
    queryKey: listId ? ['listViews', { listId }] : ['listViews'],
    queryFn: async ({ client }) => {
      const listViews = await fetchAllPages(({ cursor, take }) =>
        accountsGateway.getListViews({ cursor, take, listId }),
      );

      // if we're fetching all views, prepopulate the cache for each list
      if (!listId) {
        const viewsByListId = listViews.reduce(
          (acc, view) => {
            if (!acc.has(view.listId)) {
              acc.set(view.listId, []);
            }
            acc.get(view.listId)!.push(view);
            return acc;
          },
          // Initialize with empty arrays for each table ID. This ensures that we still have a cache entry for each
          // table, even when there are no views for it.
          new Map<string, ListViewDTO[]>(TABLE_IDS.map((id) => [id, []])),
        );

        [...viewsByListId.entries()].forEach(([id, views]) => {
          client.setQueryData(['listViews', { listId: id }], views);
        });
      }

      return listViews;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
